export default __webpack_public_path__ + "static/media/icon-ripple-login.d6f5dbae.png";